module.exports = __webpack_public_path__ + "img/f6.70f4942e.png";